module.exports = __webpack_public_path__ + "media/images/nocampaign-tablet-108f48e480a9a9c2d282f4df8bd297a8.jpg";